import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Tile from "../components/tile/Tile";
import Requests from "./requests/Requests";

export const SARs  = () => {
    const { t } = useTranslation();

    return (
        <Container fluid>
            <Row className="mb-3">
                <Col>
                    <h1>{t("dsar.title")}</h1>
                    <p className="lead">{t("dsar.description")}</p>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col xs={12} md={6} lg={4} className="mb-3">
                    <Tile   title={t("dsar.new.title")}
                            description={t("dsar.new.description")}
                            link="/sar"
                            image="/img/tiles/create-case.jpg"
                            />
                </Col>
            </Row>
            <Row className="mt-1">
                <Col>
                    <Requests />
                </Col>
            </Row>
        </Container>
    );
};